import { useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getEmployeeContractReport = async ({
  fromDate,
  toDate,
  companyCode,
  locationCode,
  contractCode,
  departmentCode,
  employeeCode,
  projectCode,
    isAllCompanies = false,
  selectedCompanyCode = "",
  userId = 0,
}) => {
  try {
    let url = isAllCompanies ? `${Api_EndPoints.AllCompanies_GetEmpContractReport}` : `${Api_EndPoints.GetEmpContractReport}`;
    let queryString = `${url}?CompanyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&LocationCode=${locationCode}&FromDate=${fromDate}&ToDate=${toDate}`;

    if (contractCode) {
      queryString += `&ContractCode=${contractCode}`;
    }
    if (employeeCode) {
      queryString += `&EmployeeCode=${employeeCode}`;
    }

    if (departmentCode) {
      queryString += `&DepartmentCode=${departmentCode}`;
    }

    if (projectCode) {
      queryString += `&ProjectCode=${projectCode}`;
    }

    if (isAllCompanies && userId !== 0) {
      queryString += `&UserId=${userId}`;
    }

    const { data } = await http_payroll.get(queryString);
    return data;
  } catch (error) {
    console.error("Error fetching employee contract report:", error);
    throw error;
  }
};

export const useGetEmpContractReport = (input) => {
  const isAllCompanies = Boolean(input?.isAllCompanies);
  const { fromDate, toDate, companyCode, locationCode } = input || {};
  const enabled = !!fromDate && !!toDate && !!companyCode && !!locationCode;

  const query = useQuery({
    queryKey: [isAllCompanies ? Api_EndPoints.AllCompanies_GetEmpContractReport : Api_EndPoints.GetEmpContractReport],
    queryFn: () => getEmployeeContractReport(input),
    refetchOnWindowFocus: false,
    enabled,
    // staleTime: 1000 * 60 * 5,
  });
  return query;
};
